








import Vue from 'vue'

export default Vue.extend({
  name: 'FavoriteButton',

  props: {
    isFavorite: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    internalIsFavorite: {
      get(): any {
        return this.isFavorite
      },
      set(val: any) {
        if (this.isFavorite !== val) {
          this.$emit('update:isFavorite', val)
        }
      },
    },
    iconClass(): string {
      return this.isFavorite ? 'ddi-star-filled' : 'ddi-star'
    },
  },
})
